'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import { useFinancesYear } from '../../../hooks/use-finances-year';
import { TitleSectionFinances } from '../../title-section-finances';
import { FilterChart } from '../filter-chart';
const TOOLTIP_CONTENT = "Explore MakerDAO's financial distribution across the 'MakerDAO Legacy', 'Atlas Immutable', and 'Scope Framework' budgets from 2021-2024. This tool helps track allocation efficiency, identify funding fluctuations, and pinpoint transitions between legacy and endgame budgets.";
function TitleFilterSection() {
  const $ = _c(5);
  const {
    year
  } = useFinancesYear();
  const RANGE = `Jan - Dec ${year}`;
  let t0;
  if ($[0] !== RANGE) {
    t0 = <TitleSectionFinances title="Expenses Metric Chart" hash="expenses-metric-chart" tooltipContent={TOOLTIP_CONTENT} range={RANGE} />;
    $[0] = RANGE;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Suspense fallback={<div>Loading...</div>}><FilterChart /></Suspense>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <div className="flex flex-row flex-wrap items-start justify-between">{t0}{t1}</div>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { TitleFilterSection };